var map = {
	"./en-au": 48428,
	"./en-au.js": 48428,
	"./en-ca": 36972,
	"./en-ca.js": 36972,
	"./en-gb": 13224,
	"./en-gb.js": 13224,
	"./en-ie": 18843,
	"./en-ie.js": 18843,
	"./en-il": 32732,
	"./en-il.js": 32732,
	"./en-in": 76579,
	"./en-in.js": 76579,
	"./en-nz": 29851,
	"./en-nz.js": 29851,
	"./en-sg": 70442,
	"./en-sg.js": 70442,
	"./ru": 89272,
	"./ru.js": 89272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23531;